import {
  APPEAL_CANCEL_REQUEST,
  APPEAL_CANCEL_SUCCESS,
  APPEAL_CANCEL_ERROR,
  APPEAL_CANCEL_RESET,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  loading: false,
  success: false,
  error: false
};

const appealCancelData = (state = initialState, action) => {
  switch (action.type) {
    case APPEAL_CANCEL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case APPEAL_CANCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true
      };
    case APPEAL_CANCEL_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      };
    case APPEAL_CANCEL_RESET:
      return initialState;
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default appealCancelData;
